import { TFunction } from 'react-i18next'
import { z } from 'zod'

const tConfig = {
  ns: 'commonEmailErrors'
}

/**
 * @param t TFunction
 * @returns arguments for zod refine method when email should be required
 */
export const emailEmptyErrorArgs = (t: TFunction) => ({
  message: t('errors.enterEmail.empty', tConfig),
  path: ['email']
})

/**
 * @param _t TFunction
 * @returns a schema with optional email fields. To make fields required use refine functions
 */
export const createAccountSettingsEmailSchema = (_t: TFunction) => {
  const t = (key: string) => _t(key, tConfig)
  return z.object({
    email: z.string()
      .regex(/^(\w+([-+_.']\w+)*@\w+([-.]\w+)*(\.[A-Za-z]{2,}))?$/, t('errors.enterEmail.invalid'))
      .optional(),
    confirmEmail: z.string().optional()
  }).refine( // Confirm Email must match email
    (d) => !d.email || d.email === d.confirmEmail,
    {
      message: t('errors.confirmEmail.matching'),
      path: ['confirmEmail']
    }
  )
}
